module.exports = __webpack_public_path__ + "static/media/onboarding-confirmation.231acd41.jpg";